import { render, staticRenderFns } from "./testRecord.vue?vue&type=template&id=20617fea&scoped=true"
import script from "./testRecord.vue?vue&type=script&lang=js"
export * from "./testRecord.vue?vue&type=script&lang=js"
import style0 from "./testRecord.vue?vue&type=style&index=0&id=20617fea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20617fea",
  null
  
)

export default component.exports